import { render, staticRenderFns } from "./PopupEditAllergy.vue?vue&type=template&id=59acdeb8&scoped=true&"
import script from "./PopupEditAllergy.vue?vue&type=script&lang=js&"
export * from "./PopupEditAllergy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59acdeb8",
  null
  
)

export default component.exports